<template>
    <div>
      <v-card class="rounded-xl" elevation="5">
        <v-card-title>
          <v-icon left>
            mdi-briefcase-account
          </v-icon>
          <span>Bank</span>
          <v-spacer></v-spacer>
          <v-icon @click="openDialog">mdi-pencil</v-icon>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col span="6">
              <label>Bank Name</label>
              <h3>Second cross cross</h3>
            </v-col>
            <v-col span="6">
              <label>ACC No.</label>
              <h3>Desacpro</h3>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-dialog v-model="dialogIsOpen">
        <BankDetailsForm :mbr="mbr" @closeDialog="closeDialog"/>
      </v-dialog>
    </div>
  </template>
  <script>
  export default {
    components:{
      BankDetailsForm:()=>import("@/components/wesupport/member/bankDetails/BankDetailsForm.vue")
    },
    data: () => ({
      dialogIsOpen: false,
    }),
    props:{
      mbr:Object,
    },
    mounted() {
  
    },
    methods: {
      openDialog() {
        this.dialogIsOpen = true;
      },
      closeDialog() {
        this.dialogIsOpen = false;
      },
    },
  };
  </script>
  